/* eslint-disable func-names */
import { StreamActions } from '@hotwired/turbo';

// Clears the inner contents of the element with id
StreamActions.clear = function() {
  const id = this.getAttribute('id');

  document.getElementById(id).replaceChildren();
};

StreamActions.redirect = function() {
  Turbo.visit(this.target)
};